<template>

<div class="insert">

    <app-icon icon="add" class="insert-icon" v-tooltip="'Add section'" v-on:click.native="$emit('click')" />

</div>

</template>

<script>

export default {

}

</script>

<style scoped>

.insert {
    margin: 10px 0px;
}

.insert:first-child {
    margin-top: 0px;
}

.insert:before {
    content: '';
    display: block;
    position: absolute;
    left: 0px;
    right: 0px;
    top: 50%;
    height: 0px;
    border-bottom: 2px solid #f7f7f7;
}

.insert-icon {
	border-radius: 20px;
	width: 40px;
    height: 40px;
    border: 2px solid #eee;
	line-height: 38px;
	text-align: center;
	cursor: pointer;
	font-size: 20px;
	background-color: #fff;
    color: #eee;
    margin: 0px auto;
}

.insert-icon:hover {
	color: #4082d3;
    border-color: #4082d3;
}

</style>